import React from 'react'
import PropTypes from 'prop-types'
import { AppliedTooltip as Tooltip, PopoverContainer, BaseSpan } from '../AppliedTooltip/AppliedTooltip'

const popoverTop = (
    <PopoverContainer title="Inhibiting fresh talent" color="#9000FF">
        Requiring past experience, especially with artificial thresholds, means
        you may miss out on the best hires.
    </PopoverContainer>
)
// Maybe try &quot;comfort with&quot;, &quot;ability to&quot;, or &quot;expertise in&quot;
class ExperienceSpan extends React.Component {
    render() {
        return (
            <span>
                <Tooltip
                    popoverContent={popoverTop}
                    disabled={!this.props.user.userId}
                >
                    <BaseSpan
                        offsetKey={this.props.offsetKey}
                        disabled={!this.props.user.userId}
                        color="#DFD0FF"
                        borderColor="#9000FF"
                    >
                        {this.props.children}
                    </BaseSpan>
                </Tooltip>
            </span>
        )
    }
}

ExperienceSpan.propTypes = {
    children: PropTypes.array,
}

export default ExperienceSpan
